<template>
  <div class="filter-season">
    <template 
      v-for="(filter, index) in filters"
      :key="index">
    <button
      type="button"
      :class="[{ selected: filter.isSelected }, 'btn filter-season-btn']"
      @mousedown="preventFocus"
      @click="selectItem(filter)"
    >
    <span v-if="filter.shortName">{{ filter.shortName }}</span>
      <span v-else>{{ filter.name }}</span>
    </button>
    </template>
  </div>
</template>
<script>
export default {
  name: "PreFilterSeasons",
  props: ["filters"],
  components: {},
  methods: {
    selectItem: function (filter) {
      filter.isSelected = !filter.isSelected;
      this.$store.dispatch("selectItem", filter.id);
    },
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
  },
};
</script>